


























import { Menu } from 'ant-design-vue'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import Icon from '../../../../components/Icon/Icon.vue'
import { MenuRoute } from "../../NewConfig";
import SidebarIcon from './SidebarIcon.vue'
import SidebarTag from './SidebarTag.vue'

@Component({
  components: {
    SidebarTag,
    SidebarIcon,
    Icon,
  },
  props: {
    ...(Menu.Item as any).props,
  },
})
export default class SidebarSingleItem extends Vue {
  @Prop({ type: Object, required: true }) item!: MenuRoute

  @Emit('routeChange')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  routeChange(): void {
  }

}
